import ArrowControls from './ArrowControls';

export default ArrowControls;
